function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not(.dontpause)').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  value() {
    return parseInt(this.input.value);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details.closest('.header-wrapper').classList.remove('menu-opened');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.mainDetailsToggle.closest('.header-wrapper').classList.add('menu-opened');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.classList.contains('custom_video')){
        deferredElement.play()
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  isFirstSlideInViewport(element, offset = 0) {
    const slider = this.slider; // Replace with your slider element
    const sliderRect = slider.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const leftEdgeOfElement = elementRect.left - offset;

    return leftEdgeOfElement >= sliderRect.left && leftEdgeOfElement <= sliderRect.right;
  }


  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.productForm = document.getElementById(`product-form-${this.dataset.section}`);
    this.qtySelector = document.querySelector('quantity-input');
    this.addButtonText = this.productForm.querySelector('[name="add"] > span');
    this.addButtonTextContent = this.addButtonText.textContent.trim().split('-')[0];
    if (this.qtySelector) {
      this.qtySelector.input.addEventListener('change', this.updateAddButtonPrice.bind(this));
    }
  }

  onVariantChange() {
    //console.log('variant changed');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariableFields();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    const event = new CustomEvent("variantChanged", {detail: this.currentVariant});
    window.dispatchEvent(event);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, 'change'));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #extra-cta`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);

        //const destinationMobile = document.getElementById(`price-mobile-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        //if (source && destinationMobile) destinationMobile.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceLast = destination.querySelector(".price-item--last");
        //debugger;
        if (priceLast) {
          window.productPrice = Math.round(parseFloat(priceLast.textContent.trim().split(' ')[0].substring(1)) * 100) ;
          updateInstallmentPrice();
        }

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        // hiding the strikethrough for standard
        const std = this.currentVariant.id === 43203297214632; // standard variant id
        const lto = document.querySelector('.price__lto');
       /* if (lto) {
          if (std) lto.classList.add('js-hidden');
          else lto.classList.remove('js-hidden');
        }*/
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      this.addButtonTextContent = addButtonText.textContent;
      this.updateAddButtonPrice();
    }

    if (!modifyClass) return;
  }

  updateAddButtonPrice() {
    if (this.addButtonText.parentElement.disabled) return;
    if (this.addButtonText === undefined) return;
    if (window.productPrice === undefined) return;
    if (this.qtySelector === undefined) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const metaContainer = this.querySelector('[type="application/variantmeta+json"]');
    if (metaContainer) {
      const variantMeta = JSON.parse(metaContainer.textContent);
      variantMeta.forEach((variant) => {
        const parentVariant = this.variantData.find(parentVariant => parentVariant.id === variant.id);
        if (!parentVariant) return;
        parentVariant.metafields = variant;
      });
    }
    return this.variantData;
  }

  updateVariableFields() {
    const elements = document.querySelectorAll(".js__product-form__variable");
    if (window.variantDetails === undefined) return;
    for (const element of elements) {
      if (element.dataset.metafield === undefined) continue;
      if (window.variantDetails[element.dataset.metafield] === undefined) continue;
      const detail = window.variantDetails[element.dataset.metafield];
      const variant = detail.find(variant => variant.options.every((value, index) => value === this.options[index]));
      if (variant === undefined) continue;
      element.innerHTML = variant.text;
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.form = this.querySelector('input').form;
    this.initCheckboxes(true);
  }

  initCheckboxes(first = false) {
    this.checkboxes = this.querySelectorAll("input[type='checkbox']");
    this.updateOptions(first);
    for (const checkbox of this.checkboxes) {
      checkbox.checked = this.form.elements[checkbox.dataset.optionName].value === 'Yes';
    }
  }

  updateOptions(first = false) {
    if (!first) {
      for (const checkbox of this.checkboxes) {
        this.form.elements[checkbox.dataset.optionName].value = checkbox.checked ? 'Yes' : 'No';
      }
    }

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


/**
 *
 */
class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.initTemplate) {
      const labels = this.dataset.labels ? this.dataset.labels.split(',') : ['days', 'hrs', 'min', 'sec'];
      const separator = this.dataset.separator ?? ':';
      this.innerHTML = `
  <div class="countdown__days-container">
    <div class="countdown__number countdown__days"> </div>
    <div class="countdown__subtitle">${labels[0]}</div>
  </div>
  <div class="countdown__days-container countdown__separator">${separator}</div>
  <div class="countdown__hours-container">
    <div class="countdown__number countdown__hours"> </div>
    <div class="countdown__subtitle">${labels[1]}</div>
  </div>
  <div class="countdown__hours-container countdown__separator">${separator}</div>
  <div>
    <div class="countdown__number countdown__minutes"> </div>
    <div class="countdown__subtitle">${labels[2]}</div>
  </div>
  <div class="countdown__seconds-container countdown__separator">${separator}</div>
  <div class="countdown__seconds-container">
    <div class="countdown__number countdown__seconds"> </div>
    <div class="countdown__subtitle">${labels[3]}</div>
  </div>
`;
    }

    this.init();

    this.days = this.querySelector('.countdown__days');
    this.hours = this.querySelector('.countdown__hours');
    this.minutes = this.querySelector('.countdown__minutes');
    this.seconds = this.querySelector('.countdown__seconds');

    this.updateRemaining();
  }

  init(reinit = false) {
    if (this.counting) {
      this.dispatchEvent(new CustomEvent('restarted'));
    } else {
      this.dispatchEvent(new CustomEvent('started'));
      this.counting = true;
    }

    this.remainingMinutes = this.dataset.remainingMinutes ? parseInt(this.dataset.remainingMinutes) : 10;
    this.restart = true;
    if (this.dataset.restart && this.dataset.restart === "no") {
      this.restart = false;
    }

    this.startTime = Date.now();

    this.mode = this.dataset.mode ?? 'visitplus';
    const d = new Date();
    switch (this.mode) {
      case 'eod':
        d.setHours(24, 0, 0, 0);
        this.endTime = d.getTime();
        break;
      case 'eow':
        const incrementDays = 7-d.getDay();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + incrementDays);
        this.endTime = d.getTime();
        break;
      case 'eom':
        d.setHours(0,0,0,0);
        d.setDate(1);
        d.setMonth(d.getMonth() + 1);
        this.endTime = d.getTime();
        break;
      case 'visitplus':
        this.endTime = this.startTime + this.remainingMinutes * 60 * 1000;
        break;
    }

    // checking if we have started already, storing time if we didnt
    const itemsString = localStorage.getItem("countDown");
    const items = itemsString === null ? {} : JSON.parse(itemsString);
    const id = this.hasAttribute('id') ? this.getAttribute('id') : '_default_';
    if (items[id] === undefined || reinit) {
      items[id] = { startTime: this.startTime, endTime: this.endTime };
      localStorage.setItem("countDown", JSON.stringify(items));
    } else {
      this.startTime = items[id].startTime;
      this.endTime = items[id].endTime;
    }

    if (this.timerId) clearInterval(this.timerId);
    this.timerId = setInterval(this.updateRemaining.bind(this), 1000);
  }

  updateRemaining() {
    const time = Date.now();
    let remainingSeconds = Math.trunc((this.endTime - time) / 1000);
    if (remainingSeconds < 0) {
      remainingSeconds = 0;
      if (this.timerId) clearInterval(this.timerId);
      this.timerId = null;
      this.counting = false;
      if (this.restart) {
        this.init(true);
      } else {
        this.dispatchEvent(new CustomEvent('stopped'));
        localStorage.removeItem('countDown');
      }
    }

    const days = Math.floor(remainingSeconds / (60*60*24));
    remainingSeconds %= (60*60*24);
    const hours = Math.floor(remainingSeconds / (60*60));
    remainingSeconds %= (60*60);
    const minutes = Math.floor(remainingSeconds / 60);
    remainingSeconds %= 60;
    const seconds = remainingSeconds;

    if (this.dataset.padding !== undefined) {
      this.days.textContent = days.toString().padStart(2, '0');
      this.hours.textContent = hours.toString().padStart(2, '0');
      this.minutes.textContent = minutes.toString().padStart(2, '0');
      this.seconds.textContent = seconds.toString().padStart(2, '0');
    } else {
      this.days.textContent = days.toString();
      this.hours.textContent = hours.toString();
      this.minutes.textContent = minutes.toString();
      this.seconds.textContent = seconds.toString();
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);

window.addEventListener("DOMContentLoaded", () => {
  const timer = document.querySelector('countdown-timer');
  if (timer) {
    const product_countdown = document.querySelector('.product__countdown,.product__countdown-new');
    if (product_countdown) {
      timer.addEventListener('stopped', () => product_countdown.classList.add('js-hidden'));
      if (!timer.counting) product_countdown.classList.add('js-hidden');
    }
  }

  const timeouts = {fade: null, hide: null};
  let notificationWidth = 0;

  // copy handler
  document.querySelectorAll('.js-copy-on-click').forEach((element) => {
    element.addEventListener('click', async () => {
      clearTimeout(timeouts.fade);
      clearTimeout(timeouts.hide);

      await navigator.clipboard.writeText(element.querySelector('.js-discount-code').textContent);

      let notification = document.querySelector('.copy-notification');
      if (!notification) {
        notification = document.createElement('div');
        notification.classList.add('copy-notification');
        notification.textContent = "Discount code copied to your clipboard  🎉";
        document.body.appendChild(notification);
        notificationWidth = notification.scrollWidth;
      }
      notification.style.top = `calc(5VH + ${window.scrollY}px)`;
      notification.style.left = `${window.innerWidth / 2 - notificationWidth / 2}px`;

      notification.classList.remove('copy-notification-fadeout');
      notification.classList.remove('js-hidden');

      timeouts.fade = setTimeout(() => notification.classList.add('copy-notification-fadeout'), 2000);
      timeouts.hide = setTimeout(() => {
        notification.classList.add('js-hidden');
      }, 2500);

    });
  });

  // collapse handler
  const collapseButton = document.querySelector('.js-countdown-collapse');
  collapseButton?.addEventListener('click', () => {
    collapseButton.parentElement.classList.toggle('product__countdown-collapsed');
  });

});



function savePreCheckoutUrl() {
  localStorage.setItem('preCheckoutUrl', location.href);
}

function restorePreCheckoutUrl() {
  // inlined in main-cart-items.liquid to avoid full load of cart page before redirect
  if (Shopify.designMode) return;
  if (Shopify.inspectMode) return;
  if (location.pathname !== '/cart') return;
  const l = localStorage.getItem('preCheckoutUrl');
  const url = l === null ? '/products/golf' : l;
  location.href = url;
}

function updateInstallmentPrice(price) {
  if (price === undefined) {
    price = window.productPrice;
  }

  if (price < 5000) {
    document.querySelectorAll(".product__title-installments")
        .forEach((element) => element.classList.add("js-hidden"));
  } else {
    document.querySelectorAll(".product__title-installments")
        .forEach((element) => element.classList.remove("js-hidden"));
    document.querySelectorAll(".js-installment-price")
        .forEach((element) => {
          element.textContent = Math.ceil(price / 200.0).toString();
        });
  }
}


/**
 * updates copy within Stamped stars widget
 */
class StampedObserver {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    this.observer = new MutationObserver(this.observe);
    this.elements.forEach((element) => this.observer.observe(element, {childList: true}));
  }

  observe(changes) {
    changes.forEach(change => {
      const reviewsText = document.querySelector(".js-stamped-placeholder")?.dataset?.reviewsText || "+ Reviews by PGA Pros, Coaches & Players";
      
      const targetSpan = change.target.querySelector(".stamped-badge-caption span");
      if (targetSpan) targetSpan.textContent = reviewsText;
      document.querySelectorAll(".js-stamped-placeholder").forEach(e => e.classList.add("hidden"));
    });
  }
}

class FadeInScroll {
  selector = '.js-fadein-scroll';
  ticking = true;

  constructor() {
    this.elements = document.querySelectorAll(this.selector);

    document.addEventListener('scroll', () => this.onScroll());
    this.onScroll();
  }

  onScroll() {
    if (!this.ticking) return;
    this.ticking = false;
    window.requestAnimationFrame(() =>{

      this.elements.forEach(element => {
        // distance from the bottom
        let y = window.innerHeight - element.getBoundingClientRect().y;
        // skip first 10%
        y -= window.innerHeight*0.1;
        // percentage
        let percentage = y / window.innerHeight;
        if (percentage < 0) percentage = 0;
        // picking the first 33% as the fadein area
        percentage *= 3;
        if (percentage > 1) percentage = 1;
        element.style.opacity = percentage.toFixed(5);
      });

      this.ticking = true;
    });
  }
}

class ByGolfersForGolfers {

  hiddenClass = "element-hidden";

  constructor() {
    this.screenWidth = window.innerWidth;

    const containerSelector = this.screenWidth < 750 ? ".product__for-golfers-container.mobile" : ".product__for-golfers-container.desktop";

    this.container = document.querySelector(containerSelector);
    if (!this.container) return;

    /** @type HTMLElement[] */
    this.elements = Array.from(this.container.querySelectorAll('.product__for-golfers'));
    this.setElement(0);
    this.updateHeight();

    setInterval(this.advance.bind(this), 6000);
  }

  updateHeight() {
    const height = Math.max(...this.elements.map(element =>
      element.querySelector('.product__for-golfers-wrapper').offsetHeight
    ));
    this.container.style.height = height + "px";
  }

  advance() {
    this.setElement(this.activeElement + 1);
    this.updateHeight(); // effectively for resize only now
  }

  setElement(activeElement) {
    this.activeElement = activeElement % this.elements.length;
    this.elements.forEach((element, index) => {
      if (index === this.activeElement) element.classList.remove(this.hiddenClass);
      else element.classList.add(this.hiddenClass);
    });
  }

}

/**
 * Stamped widget loads delayed and causes page scroll jump when initial pageload is #scholarship or anything below the widget
 * this observer rescrolls the page compensating for the widget height
 */
class StampedReviewsObserver {
  constructor() {
    this.stampedElement = document.getElementById('stamped-main-widget');
    if (!this.stampedElement) return;

    //console.log(`Height: ${this.stampedElement.clientHeight}`);

    this.observer = new MutationObserver(() => this.stampedMutated());
    this.observer.observe(this.stampedElement, {childList: true});

    //window.addEventListener('scroll', (e) => this.scroll(e));
  }

  stampedMutated() {
    //console.log(`Height: ${this.stampedElement.clientHeight}`);

    const stampedPos = this.stampedElement.getBoundingClientRect().top + window.scrollY;
    //console.log('StampedPos = ' + stampedPos);
    //console.log('WindowY = ' + window.scrollY);

    if (location.hash !== '') {
      const element = document.querySelector(location.hash);
      if (element) element.scrollIntoView();
    }
    // only when we are below stamped at the moment it loads
    //if (window.scrollY > stampedPos + this.stampedElement.clientHeight) {
    //  console.log('rescrolling');


      // window.scrollTo(
      //   {
      //     top: window.scrollY + this.stampedElement.clientHeight,
      //     left: window.scrollX,
      //     behavior: 'instant'
      //   }
      // );
    //}
    //this.observer.disconnect();
  }
}

window.addEventListener("DOMContentLoaded", function () {
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  new StampedObserver(".stamped-js");

  updateInstallmentPrice();

  // collapsible animation
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('.accordion summary');
      this.content = el.querySelector('.accordion .accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('.accordion details').forEach((el) => {
    new Accordion(el);
  });

  new FadeInScroll();

  new ByGolfersForGolfers();

  new StampedReviewsObserver();
});

window.addEventListener("addToCart", function(event) {
  let eventName = "add_to_cart";
  if (location.pathname === '/pages/quiz') {
    eventName = "add_to_cart_quiz";
  }

  if (event.detail.properties && event.detail.properties.tbybEnabled !== undefined) {
    eventName = "bc.add_to_cart";
  }

  const items = event.detail.items ?
    event.detail.items.map(item => ({
      item_id: item.sku,
      item_name: item.title,
      currency: "USD",
      price: item.final_price / 100.0,
      quantity: item.quantity
    })) :
    [{
      item_id: event.detail.sku,
      item_name: event.detail.title,
      currency: "USD",
      price: event.detail.final_price / 100.0,
      quantity: event.detail.quantity
    }];

  // GTM
  window.dataLayer=window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      items: items
    }
  });

  // FS
  if (window.FS) {
    window.FS.event(
      eventName,
      items[0]);
  }

  // Convert
  window._conv_q = window._conv_q || [];
  window._conv_q.push(["triggerConversion", "10048034"]);

});


/*
window.addEventListener("load", function () {
  // adding UTM params to BlackCart URL
  // blackcart handles by itself:  utm_source, utm_medium, utm_campaign, utm_term, utm_content
  // adding: gclid
  const params = ["gclid", "campaignid"];
  const u = new URL(location);
  if (u.search === '') return;
  let obj = {};
  for (const param of params.filter(param => u.searchParams.has(param))) {
    obj[param] = u.searchParams.get(param);
  }

  let bc_utms_obj = {};
  const bc_utms_str = localStorage.getItem('bc_tbyb_utm_params');
  if (bc_utms_str !== null) {
    bc_utms_obj = JSON.parse(bc_utms_str);
  }

  Object.assign(bc_utms_obj, obj);

  localStorage.setItem('bc_tbyb_utm_params', JSON.stringify(bc_utms_obj));
});

*/

/**
 * for Homepage CRO Convert experience
 * https://app.convert.com/accounts/10041372/projects/10042096/experiences/1004139719/summary
 * if it is finished, remove this code
 */

if (document.referrer !== '') {
  const current = new URL(location);
  const ref = new URL(document.referrer);

  // click to PDP at HomePage
  if (current.pathname === '/products/golf' && ref.pathname === '/') {
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100491509"]);
    //console.log("Conv push");
  }

  // click from the TPV
  if (ref.host === 'tourgrade.golf') {
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100492460"]);
    //console.log("Conv push");
  }
}
